module.exports = __webpack_public_path__ + "img/blog-3-2.35a55ba3.webp";